import React, { Component } from 'react';
import DynamicTable from './DynamicTable';
import DailyCard from './DynamicCurrentDateCards';
import { getFinancialsData } from '../../actions/financials';
import moment from 'moment';

class RevPlanComp extends Component {
  constructor() {
    super();
    this.state = {
      planCard: ['Date', 'Amount', 'Amount(till now)'],
      numberType: { free: 20, similar: 3, premium: 3, vip: 40 },
      planType: { plan1: 10, plan2: 30, plan3: 40 },
      from: null,
      to: null,
      revenueData: [],
      revenueDataToday: '',
      error: ''
    }
  }


  componentDidMount() {
    let fromDate = moment().subtract(10, 'days').format();
    let tillDate = moment().format();
    var todayStart = moment().format();
    var todayEnd = moment().add(1, 'day').format();


    getFinancialsData({
      searchCategory: 'revenue',
      from: fromDate,
      to: tillDate
    })
      .then(resp => { return resp.response.registrationStats })
      .then(resp => { this.setState({ revenueData: resp }) })
      .catch(err => console.log('err'));


    getFinancialsData({
      searchCategory: 'revenue',
      from: fromDate,
      to: tillDate
    })
      .then(resp => { return resp.response.registrationStats })
      .then(resp => { this.setState({ revenueDataToday: resp[0] }) })
      .catch(err => console.log('err'));

    // console.log(tod)
    // getFinancialsData({
    //   searchCategory: 'total_revenue',
    //   from: todayStart,
    //   to: todayEnd
    // })
    //   .then(resp => { return resp.response.registrationStats })
    //   .then(resp => { this.setState({ revenueDataToday: resp[0].total_revenue / 100 }) })
    //   // .then(resp => { this.setState({ revenueData: resp }) })
    //   .catch(err => console.log('err'));

  }

  onChange = e => {
    this.setState({ [e.target.id]: e.target.value });
  };

  getRevenueHandler = () => {
    let today = moment().format("YYYY-MM-DD");
    if (this.state.from == null || this.state.to == null) return this.setState({ error: 'provide input dates' });
    if (this.state.from > this.state.to) return this.setState({ error: 'from can not be greater than till data' });
    if (this.state.to > today) return this.setState({ error: 'no future dates' });
    this.setState({ error: '', reportData: [] });

    getFinancialsData({ searchCategory: 'total_revenue', from: this.state.from, to: this.state.to })
      .then(resp => { return resp.response.registrationStats })
      .then(resp => { this.setState({ revenueData: resp }) })
      .catch(err => {
        console.log('err');
      })
  }


  render() {
    return (
      <div>


        <h1>Total revenue (till date) and today's revenue </h1>

        <input
          type="date"
          id="from"
          value={this.state.from}
          onChange={this.onChange}
        />
        <input
          type="date"
          id="to"
          value={this.state.to}
          onChange={this.onChange}
        />
        <button onClick={this.getRevenueHandler}>Search</button>
        <p style={{ 'color': 'red' }}>{this.state.error}</p>





        <table style={{ 'marginBottom': '30px' }}>
          <tr>
            <th colspan="2">Today</th>
          </tr>
          <tr>
            <th>Today</th>
            <th>Total (till now)</th>
          </tr>
          <td>{this.state.revenueDataToday.total_revenue / 100}</td>
          <td>{this.state.revenueDataToday.total_revenue_till_date / 100}</td>
        </table>





        <DynamicTable headerData={this.state.planCard} tableData={this.state.revenueData} dataType="revenue" />
      </div>
    )
  }
}



export default RevPlanComp;